import useWindowBeforeUnload from './useWindowBeforeUnload';
import UploadFilesStore from '../../stores/UploadFilesStore';

const useUploadCompletion = (uploadFilesStore: UploadFilesStore): void => {
    useWindowBeforeUnload(() => uploadFilesStore.isUploading);
};

export default useUploadCompletion;
